import logo from './code_and_theory_logo.png';
import cta_default from './cta_default.png';
import default_image from './default_image.png';
import art_frame from './art_frame.png';
import './App.css';
const file_saver = require('./FileSaver');

let image_link = "";
let image_key = "";
const getImage = () => {
  const url_string = window.location.href;
  const url = new URL(url_string);
  const params = new URLSearchParams(url.search);
  image_key = params.get("image");
  if (!image_key)
  {
    image_link = default_image;
  }
  else
  {
    image_link = "https://pop-a-shot-test.s3.us-west-1.amazonaws.com/" + image_key + ".png";
  }

};

function saveImage(){
  if (!image_key)
  {
    shareImage(image_link, "pop-a-shot_cta_default" + ".png");
  }
  else
  {
    shareImage(image_link, "pop-a-shot_" + image_key + ".png");
  }
}

async function downloadImage(imageSrc, image_name) {
  const image = await fetch(imageSrc)
  const imageBlog = await image.blob()
  const imageURL = URL.createObjectURL(imageBlog)

  const link = document.createElement('a')
  link.href = imageURL
  link.download = image_name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

}

async function shareImage(imgSrc, filename = 'image.png') {
  try {
      const response = await fetch(imgSrc);
      const blob = await response.blob();
      const file = new File([blob], filename, { type: blob.type });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({
              files: [file],
              title: 'Pop-A-Shot',
              text: 'JOIN THE PACK'
          });
      } else {
          downloadImage(imgSrc, filename)
      }
  } catch (error) {
      downloadImage(imgSrc, filename)
  }
}

function PopAShot() {
  getImage();
  return (
    <div className="App noselect">
        <div className="Logo">
        <img noselect id="logo" src={logo} />
        </div>
        <div className="Cta1">
          <div className="CtaText1 noselect">
          THANKS FOR PLAYING
          </div>
        </div>
        <div className="Artwork">
        <img id="art" src={image_link} />
        <img id="frame" src={art_frame} />
        </div>
        <div className="Cta2">
          <img id="art_cta" src={cta_default} />
        </div>
        <div className="Button">
        <button onClick={() => { saveImage() }}>DOWNLOAD IMAGE</button>
        </div>
    </div>
  );
}


export default PopAShot;
